import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

async function getMasterService(masterServiceId) {
  const response = await axiosPrivate.get(`/v3/support/master-services/${masterServiceId}`);
  return response.data;
}

export default function useMasterService(masterServiceId) {
  return useQuery({
    queryKey: ['master-service', masterServiceId],
    queryFn: () => getMasterService(masterServiceId),
    enabled: !!masterServiceId,
    cacheTime: 5 * 60 * 1000, // 5 minutes
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
